import React from 'react'

const ChevronUp = ({ action }) => {
    return(
        <button
            className="green-button"
            onClick={action}
        >
            <i className="fas fa-chevron-up"/>
        </button>
    )
}

export default ChevronUp


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/ChevronUp.jsx